import Fetch from "@/fetch/index";
import axios from "@/axios/index";
//State
const state = {
  currentTaskList: null,
  taskLists: [],
  currentTask: null,
  filters: {
    status: null,
    assigneeId: null,
    customerId: null,
    priority: null,
    search: "",
  },
  groupBy: "kanban_group", // kanban_group, assignee, customer, priority, status
};

//Getters
const getters = {
  currentTaskList: (state) => state.currentTaskList,
  taskLists: (state) => state.taskLists,
  currentTask: (state) => state.currentTask,
  filters: (state) => state.filters,
  groupBy: (state) => state.groupBy,
};

//Actions
const actions = {
  // Task Lists
  loadTaskLists(context) {
    return new Promise((resolve, reject) => {
      Fetch.get("/api/v1/task_lists")
        .then((response) => {
          context.commit("setTaskLists", response.data.task_lists);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  loadTaskListById(context, taskListId) {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      if (context.state.filters.status)
        params.append("status", context.state.filters.status);
      if (context.state.filters.assigneeId)
        params.append("assignee_id", context.state.filters.assigneeId);
      if (context.state.filters.customerId)
        params.append("customer_id", context.state.filters.customerId);
      if (context.state.filters.priority)
        params.append("priority", context.state.filters.priority);
      if (context.state.filters.search)
        params.append("search", context.state.filters.search);
      if (context.state.groupBy)
        params.append("group_by", context.state.groupBy);

      const queryString = params.toString();
      const url = `/api/v1/task_lists/${taskListId}${queryString ? "?" + queryString : ""}`;

      Fetch.get(url)
        .then((response) => {
          context.commit("setCurrentTaskList", response.data.task_list);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  loadDefaultTaskList(context) {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      if (context.state.filters.status)
        params.append("status", context.state.filters.status);
      if (context.state.filters.assigneeId)
        params.append("assignee_id", context.state.filters.assigneeId);
      if (context.state.filters.customerId)
        params.append("customer_id", context.state.filters.customerId);
      if (context.state.filters.priority)
        params.append("priority", context.state.filters.priority);
      if (context.state.filters.search)
        params.append("search", context.state.filters.search);
      if (context.state.groupBy)
        params.append("group_by", context.state.groupBy);

      const queryString = params.toString();
      const url = `/api/v1/task_lists/default${queryString ? "?" + queryString : ""}`;

      Fetch.get(url)
        .then((response) => {
          context.commit("setCurrentTaskList", response.data.task_list);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  createTaskList(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/v1/task_lists", { task_list: data })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateTaskList(context, { taskListId, data }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/task_lists/${taskListId}`, { task_list: data })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  deleteTaskList(context, taskListId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v1/task_lists/${taskListId}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  duplicateTaskList(context, taskListId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/v1/task_lists/${taskListId}/duplicate`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // Tasks
  loadTaskById(context, taskId) {
    return new Promise((resolve, reject) => {
      Fetch.get(`/api/v1/tasks/${taskId}`)
        .then((response) => {
          context.commit("setCurrentTask", response.data.task);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  createTask(context, { taskListId, data }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/v1/task_lists/${taskListId}/tasks`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateTask(context, { taskId, data }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/tasks/${taskId}`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  deleteTask(context, taskId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v1/tasks/${taskId}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  toggleTaskCompletion(context, taskId) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/tasks/${taskId}/toggle_completion`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  reorderTasks(context, { taskListId, taskIds }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/task_lists/${taskListId}/tasks/reorder`, {
          task_ids: taskIds,
          meta: {
            contentType: "application/json",
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // Filters
  setFilters(context, filters) {
    context.commit("setFilters", filters);
  },

  setGroupBy(context, groupBy) {
    context.commit("setGroupBy", groupBy);
  },

  clearFilters(context) {
    context.commit("clearFilters");
  },
};

//Mutations
const mutations = {
  setTaskLists(state, taskLists) {
    state.taskLists = taskLists;
  },

  setCurrentTaskList(state, taskList) {
    state.currentTaskList = taskList;
  },

  setCurrentTask(state, task) {
    state.currentTask = task;
  },

  setFilters(state, filters) {
    state.filters = { ...state.filters, ...filters };
  },

  setGroupBy(state, groupBy) {
    state.groupBy = groupBy;
  },

  clearFilters(state) {
    state.filters = {
      status: null,
      assigneeId: null,
      customerId: null,
      priority: null,
      search: "",
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
